import { combineReducers } from '@reduxjs/toolkit';
import { bookingCreatorReducers } from 'booking-creator/rootReducer';
import { bookingCardListReducers } from 'booking-card-list/rootReducer';
import statusReducer from 'app/reducers/status/slice';
import venueReducer from 'app/reducers/venue/slice';
import authReducer from 'app/reducers/auth/slice';
import pouchReducer from 'app/reducers/pouch/slice';
import rootDisplayReducer from 'app/reducers/display/slice';
import scheduleReducer from 'app/reducers/schedule/slice';
import layoutReducer from 'app/reducers/layout/slice';
import bookingReducer from 'app/reducers/booking/slice';
import sectionReducer from 'app/reducers/section/slice';
import serviceReducer from 'app/reducers/service/slice';
import accountReducer from 'app/reducers/account/slice';
import settingReducer from 'app/reducers/settings/slice';
import quickValidationReducer from 'app/reducers/quickValidation/slice';
import errorStateReducer from 'app/reducers/errorState/slice';
import resizerReducer from 'app/reducers/resizer/slice';
import { floorplanV2Reducers } from 'floorplan-v2/app/appRoot/rootReducer';
import staffValidationReducer from 'app/reducers/staffValidation/slice';
import globalSearchModalReducer from 'app/reducers/globalSearchModal/slice';

const diaryReducer = combineReducers({
  // reducers from Diary go at the top
  authReducer,
  errorStateReducer,
  statusReducer,
  venueReducer,
  pouchReducer,
  rootDisplayReducer,
  scheduleReducer,
  layoutReducer,
  bookingReducer,
  sectionReducer,
  serviceReducer,
  accountReducer,
  settingReducer,
  quickValidationReducer,
  resizerReducer,
  staffValidationReducer,
  globalSearchModalReducer,
  // reducers from submodules must be merged (using spread operator)
  ...bookingCreatorReducers,
  ...bookingCardListReducers,
  ...floorplanV2Reducers,
});

export type DiaryRootState = ReturnType<typeof diaryReducer>;

export default diaryReducer;
